var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10314 0.555303L6.06251 4.6928L1.49689 5.35843C0.67814 5.47718 0.350015 6.48655 0.943765 7.06468L4.24689 10.2834L3.46564 14.8303C3.32501 15.6522 4.19064 16.2678 4.91564 15.8834L9.00002 13.7366L13.0844 15.8834C13.8094 16.2647 14.675 15.6522 14.5344 14.8303L13.7531 10.2834L17.0563 7.06468C17.65 6.48655 17.3219 5.47718 16.5031 5.35843L11.9375 4.6928L9.89689 0.555303C9.53127 -0.182197 8.47189 -0.191572 8.10314 0.555303Z",
    fill: "#F72B94"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.c181d31b.svg";
export { ForwardRef as ReactComponent };